import { Modal } from '@wapharma/design-system';
import { ProfileSettingsSection } from './ProfileSettingsSection';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export function EditProfileModal({ opened, onClose }: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title="Modifier le profil" size="sm">
      {opened ? <ProfileSettingsSection /> : null}
    </Modal>
  );
}
